__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/web-rel-26.10.2-3e5f9d6-19013/_next/";